import { NgModule } from '@angular/core';
import { MediaBankPreviewComponent } from './media-bank-preview.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
@NgModule({
    imports: [CommonModule, FiVimeoModule, MatIconModule, FiDirectivesModule, FiAttachmentsModule],
    declarations: [MediaBankPreviewComponent],
    exports: [MediaBankPreviewComponent],
})
export class MediaBankPreviewModule {}
